import React from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useTranslation } from "react-i18next"

const ConsumptionAnalytic = ({ data }: any) => {
  const percentage = Math.min(
    ((data.total - data.used) / data.total) * 100,
    100
  )

  const { t } = useTranslation()

  return (
    <Card className="shadow-md rounded-3">
      <CardBody className="p-3">
        <p>
          <span className="text-muted text-12px">
            {t("coupons_consumptionAnalytics")}
          </span>
        </p>

        {Object.keys(data).length > 0 && (
          <div className="mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <span className="font-size-16 text-semi-dark fw-semibold">
                {t("coupons_useageState")}
              </span>
              <p className="mb-0 text-muted">
                <span className="badge font-size-12 mx-2 bg-primary-30 text-primary">
                  {data.total - data.used} {t("common_left")}
                </span>
              </p>
            </div>
            <div
              className="progress bg-primary-20 rounded-full mt-2"
              style={{ height: "12px" }}
            >
              <div
                className="progress-bar bg-primary"
                role="progressbar"
                style={{ width: `${percentage}%` }}
              >
                {data.used} / {data.total}
              </div>
            </div>
          <div className="d-flex w-full justify-content-between mt-1">
            <span className="text-primary font-size-12">
              {data.total} {t("orders_total")}
            </span>
            <span className="text-primary font-size-12">
              {data.used} {t("orders_used")}
            </span>
            <span className="text-primary font-size-12">
              {data.total - data.used} {t("orders_remaining")}
            </span>
          </div>
          </div>
        )}
        <div>
          <Row className="font-size-12">
            <Col
              md={7}
              className="col-form-label text-start flex align-items-center text-muted fw-medium"
            >
              {t("coupons_avgConsumption")}
            </Col>
            <Col
              md={5}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="fw-semibold m-0">{data.avgConsumption}</p>
            </Col>
          </Row>
          <Row className="font-size-12">
            <Col
              md={7}
              className="col-form-label text-start flex align-items-center text-muted fw-medium"
            >
              {t("coupons_nextRedirectRefill")}
            </Col>
            <Col
              md={5}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="fw-semibold m-0">{data.nextRedirectRefill}</p>
            </Col>
          </Row>
          <Row className="font-size-12">
            <Col
              md={7}
              className="col-form-label text-start flex align-items-center text-muted fw-medium"
            >
              {t("coupons_estCompletionDate")}
            </Col>
            <Col
              md={5}
              className="d-flex align-items-center col-form-label text-start"
            >
              <p className="fw-semibold m-0">{data.estCompletionDate}</p>
            </Col>
          </Row>
        </div>
        <div className="my-4">
          <span className="font-size-14 text-semi-dark fw-medium">
            {t("coupons_consumbtionHabit")}
          </span>
          <p className=" text-muted fw-medium font-size-12">
            {data.consmptionHabit}
          </p>
        </div>
        <div className="my-4">
          <h5 className="font-size-14 text-semi-dark fw-medium mb-3">
            {t("coupons_consumptionAddress")}
          </h5>
          {data.consumptionAddress.length > 0 &&
            data.consumptionAddress.map((address: any, index: number) => (
              <Card className="shadow-md rounded-3 mb-2" key={index}>
                <div
                  className="border rounded d-flex align-items-center justify-content-between px-3 py-2"
                  style={{
                    cursor: "pointer",
                    minWidth: "180px",
                    height: "45px",
                  }}
                  onClick={() => {
                    // Dummy coordinates for Doha, Qatar
                    const lat = 25.286106
                    const lng = 51.534817
                    const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`
                    window.open(url, "_blank")
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <i className="mdi mdi-map-marker font-size-18 text-muted"></i>
                    <div>
                      <div className="fw-semibold font-size-14">
                        {address.type}
                      </div>
                      <div className="text-muted font-size-10">
                        {address.address.substring(0, 15)}...
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="badge bg-primary-20 text-primary font-size-12 rounded-circle"
                      style={{ width: "24px", height: "24px", padding: "4px" }}
                    >
                      {address.count}
                    </span>
                    {address.default && (
                      <i className="mdi mdi-star text-primary font-size-18"></i>
                    )}
                  </div>
                </div>
              </Card>
            ))}
        </div>
      </CardBody>
    </Card>
  )
}

export default ConsumptionAnalytic
